// extracted by mini-css-extract-plugin
module.exports = {"root":"br_b","headings":"br_c2","dividerAnimation":"br_p"};